<template>
  <div>
    <template v-if="item == false">
      <div class="row">
        <div class="col-12" style="height: 300px;">
          {{message}}
        </div>
      </div>
    </template>
    <template v-else-if="verified == false">
      <div class="row">
        <div class="col-12">
          본인 확인을 위해 전화번호를 입력해주세요.
        </div>
        <div class="col-12">
          <input type="tel" v-model="phoneNumber" class="form-control"/>
        </div>
        <div class="col-12">
          <button class="btb btn-success form-control" @click="verify">확인</button>
        </div>
      </div>

    </template>
    <template v-else>
      <div class="row">

        <div class="col-12">
          Case: {{item.reference}}
        </div>
      </div>
      <div class="row">

        <div class="col-12">
          믈품 리스트
        </div>
        <hr/>
        <div class="col-12">
          <table class="table text-left">
            <tr>
              <th>품목</th>
              <th>위치</th>
              <th>크기</th>
              <th></th>
            </tr>
            <tr v-for="(g, gi) in item.items" v-on:click="editGoodItem = g">
              <td>{{g.title}}</td>
              <td>{{g.location}}</td>
              <td>{{g.size}}</td>
              <td><span v-on:click.stop="deleteGoodItem(gi)"><i class="fas fa-trash"></i></span></td>
            </tr>
          </table>
          <button class="btn btn-success" @click="prepareNewGood">물품 추가</button>

        </div>
      </div>
    </template>
    <div v-if="editGoodItem != false" style="position: fixed; top:0; left:0; width: 100%; height: 100%; background-color: rgba(0,0,0,0.5); z-index: 2;" v-on:click="editGoodItem = false">
      <div style="position: absolute; top: 50%; left: 50%; width: 90%; max-width: 500px; height: 90%; transform: translate(-50%, -50%); background-color: white; border-radius: 10px; overflow:hidden; box-shadow: 3px 3px 5px black;"
           v-on:click.stop="dummy">
        <div class="container" style="padding-top:0;padding-bottom: 0; background-color: #E5E5E5; font-weight: bold;">
          <div class="row">
            <div class="col-12"><span v-if="editGoodItem.id == 0">물품 추가</span><span v-else>물품 수정</span></div>
          </div>

        </div>
        <div class="container" style="height: calc(100% - 100px); overflow-y: auto;">
          <div class="row" v-if="editGoodItem.id > 0">
            <div class="col-12" style="font-weight: bold;">
              사진
              <img v-if="editGoodItem.imageUrl != null && editGoodItem.imageUrl.length > 0" :src="editGoodItem.imageUrl" style="width: 100%;"/>
            </div>
            <div class="col-12">
              <progress value="0" max="100" id="uploader"></progress>
              <input accept="image/*" type="file" ref="file" value="upload" @change="imageSelected" data-buttonText="사진 선택">
            </div>
          </div>
          <div class="row">
<!--            <div class="col-12" style="font-weight: bold;">-->
<!--            품명-->
<!--            </div>-->
            <div class="col-12">
              <span style="font-weight: bold;">품명</span>
              <input type="text" v-model="editGoodItem.title" class="form-control" placeholder="직접입력"/>
            </div>
            <div class="col-12">
              아래에서 선택하세요
              <div style="display: inline-block; padding:0;">
                <div style="padding:5px; float: left; margin:3px; border:1px solid gray;" v-for="(ex, ei) in goodExamples" v-on:click="editGoodItem.title = ex.title">{{ex.title}}</div>
              </div>
            </div>
          </div>
          <hr/>
          <div class="row">
<!--            <div class="col-12" style="font-weight: bold;">-->
<!--            -->
<!--            </div>-->
            <div class="col-12">
              <span style="font-weight: bold;">위치</span>

              <input type="text" v-model="editGoodItem.location" class="form-control" placeholder="직접입력"/>
            </div>
            <div class="col-12">
              아래에서 선택하세요
              <div style="display: inline-block; padding:0;">
                <div style="padding:5px; float: left; margin:3px; border:1px solid gray;" v-for="(loc, li) in locationList" v-on:click="editGoodItem.location = loc.title">{{loc.title}}</div>
              </div>
            </div>
          </div>
          <hr/>
          <div class="row">
<!--            <div class="col-12" >-->

<!--            </div>-->
            <div class="col-12">
              <span style="font-weight: bold;">크기</span>
              <input type="text" v-model="editGoodItem.size" class="form-control" placeholder="직접입력"/>
            </div>
            <div class="col-12">
              아래에서 선택하세요
              <div style="display: inline-block; padding:0;">
                <div style="padding:5px; float: left; margin:3px; border:1px solid gray;" v-for="(size, li) in sizeList" v-on:click="editGoodItem.size = size.title">{{size.title}}</div>
              </div>
            </div>
          </div>
          <hr/>
        </div>
        <div class="container" style="padding-top:0;padding-bottom: 0;">
          <div class="row">
            <div class="col-6">
              <button class="btn btn-dark form-control" @click="editGoodItem = false">닫기</button>
            </div>
            <div class="col-6">
              <button class="btn btn-success form-control" @click="updateNewGood">완료</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import {getRequest} from "../api/request";
    import {showDialog} from "../api/utils";
    import {deleteGoodItem, getGoodSizeList, getGoodsTemplates, getLocationList, submitGoodItem} from "../api/goods";
    import moment from 'moment';

    import firebase from "firebase/app";
    export default {
      name: "Item",
      data() {
          return {
            item:false,
            message:'Loading',
            phoneNumber:'',
            verified:false,
            editGoodItem:false,
            locationList: [],
            sizeList: getGoodSizeList(),
            goodExamples:[],
          }
      },
      created() {
        this.getItem();
      },
      mounted() {
      },
      beforeDestroy() {
      },
      destroyed() {
      },
      methods: {
        dummy: function(){

        },
        getItem: function() {
          let self = this;

          let id = 0;
          if(this.$route.params.hasOwnProperty("id")) {
            id = this.$route.params.id;
          } else if(this.$route.query.hasOwnProperty("id")){
            id = this.$route.query.id;
          } else {
            this.$data.message = "유효하지 않는 페이지입니다.";
            return;
          }
          getRequest(id)
          .then(function(data) {
            if(data.success == true) {
              self.$data.item = data.item;
              self.getLocationList();
            }

          })
          .catch(function(err) {
            console.log(err);
            if(err.response != undefined) {
              console.log(err.response);
            }
          })
        },
        verify: function() {
          if(this.$data.item == null || this.$data.item == false) {
            this.$data.message = "링크를 다시 확인해주세요";
            showDialog("링크를 다시 확인해주세요");
            return;
          }

          if(this.$data.phoneNumber === this.$data.item.phoneNumber) {
            this.$data.verified = true;
            this.getGoodsSelectionList();
            this.sortGoods();
          } else {
            console.log("not matching");
            showDialog("전화번호가 맞지 않습니다.");
          }
        },

        getGoodsSelectionList: function() {
          let self = this;
          getGoodsTemplates("item_example")
          .then(function(data) {
            if(data.success == true) {
              self.$data.goodExamples = data.item;
            }
          })
          .catch(function(err) {

          })
        },
        getLocationList: function() {
          let self = this;
          getGoodsTemplates('location', 'pos')
          .then(function(data) {
            if(data.success == true) {
              self.$data.locationList = data.item;
            }
          })
        },
        prepareNewGood: function() {
          let item = {
            id:0,
            requestId:this.$data.item.id,
            type:'item',
            location:'',
            size:'',
            amount:1,
            title:'',
          };

          this.$data.editGoodItem = item;
        },
        imageSelected: function(e) {
          const uploader = document.getElementById('uploader');
          //get file
          console.log("File Btn Added");
          console.log(e);
          let getFile = e.target.files[0];
          console.log("File name - " + getFile.name);
          //set storage ref
          let d = new Date();
          let name  =  moment(d).format('YYYYMMDD-hhmmss');
          let names = getFile.name.split('.');

          let path = 'move-jobs/' + this.$data.editGoodItem.requestId + "/"  + this.$data.editGoodItem.id + '-' + name + '.' + names[names.length-1];
          let storageRef = firebase.storage().ref();
          let mountainsRef = storageRef.child(path);
          let self = this;
          mountainsRef.put(getFile).on('state_changed',
            function progress(snapshot){

              let percentage = (snapshot.bytesTransferred / snapshot.totalBytes) *100;
              console.log("percentage " + percentage);
              uploader.value = percentage;
            },
            function error(err){
              console.log(err);
            },
            function complete(){
              console.log('complete upload');
              self.$data.editGoodItem.imageUrl = 'https://storage.googleapis.com/uko-projects.appspot.com/' + path;
              self.updateNewGood();
            }
          );
        },
        deleteGoodItem: function(index) {
          if(this.$data.item.items[index].id == 0) {
            this.$data.item.items.splice(index, 1);
            return;
          }

          let self = this;
          deleteGoodItem(this.$data.item.items[index].id)
          .then(function(data) {
            if(data.success == true) {
              self.$data.item.items.splice(index, 1);
            } else {
              showDialog(data.message);
            }
          })
          .catch(function(err) {
            console.log(err);
            if(err.response != undefined) {
              console.log(err.response);
            }
            showDialog("죄송합니다. 다시 시도해주세요", "에러");
          })
        },
        updateNewGood: function() {

          let self = this;
          let isNew = false;
          if(this.$data.editGoodItem.id == 0) {
            isNew = true;
          }
          submitGoodItem(this.$data.editGoodItem)
          .then(function(data) {
            if(data.success) {
              if(isNew) {
                self.$data.editGoodItem = false;
                self.$data.item.items.push(data.item);
                self.sortGoods();
              } else {
                for(let i = 0 ; i < self.$data.item.items.length ; i++) {
                  if(self.$data.item.items[i].id == data.item.id) {
                    self.$data.item.items.splice(i, 1, data.item);
                    self.sortGoods();
                    return;
                  }
                }
              }
            } else {
              showDialog(data.message);
            }
          })
          .catch(function(err) {
            console.log(err);
            if(err.response != undefined) {
              console.log(err.response);
            }
            showDialog("죄송합니다 나중에 다시 시도해주세요.", "에러");
          })
        },
        sortGoods: function() {
          if(this.$data.locationList == null || this.$data.locationList.length == 0) {
            return;
          }

          console.log("Location List");
          console.log(this.$data.locationList);
          let self = this;
          this.$data.item.items.sort(function(a, b) {
            let aPos = 0;
            let bPos = 0;
            for(let i = 0 ; i < self.$data.locationList.length ; i++) {
              if(self.$data.locationList[i].title === a.location) {
                aPos = self.$data.locationList[i].pos;
                break;
              }
            }
            for(let i = 0 ; i < self.$data.locationList.length ; i++) {
              if(self.$data.locationList[i].title === b.location) {
                bPos = self.$data.locationList[i].pos;
                break;
              }
            }

            console.log(a.title + " " + a.location + " pos " + aPos + " " + b.title + " " + b.location + " pos " + bPos);
            if(aPos < bPos) {
              return -1;
            } else if(aPos > bPos) {
              return 1;
            }
            return 0;

          })
        },
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/MoveItem.vue